import classNames from 'classnames'
import moment from 'moment'
import { FC } from 'react'
import { BrandDashboard } from 'src/services/aiListeningApi/brandProfile.types'
import { DeltaBadge } from './DeltaBadge'
import styles from './dashboard.module.scss'
import { AreaChart } from '../charts/AreaChart'
import { StanceSplit } from '../charts/StanceSplit'
import { Pill } from '../Pill'
import { formatCompact, formatNumber } from '../utils'

interface ReachCardProps {
  brandName: string
  reach: BrandDashboard['reach']
}

export const ReachCard: FC<ReachCardProps> = ({ brandName, reach }) => (
  <section className={classNames(styles.card, styles.reachCard)}>
    <div className={styles.reachHeading}>
      <h2 className={styles.reachTitle}>Audience Reach</h2>
      <Pill tone="purple">Estimated</Pill>
    </div>
    <div className={styles.reachValueRow}>
      <span className={styles.reachValue}>{formatCompact(reach.value)}</span>
      <DeltaBadge kind="percent" value={reach.delta} />
    </div>
    {/* One line (QA, 2026-10-21); a long brand name ellipsizes. */}
    <p
      className={styles.reachCaption}
      title={`people see ${brandName} in AI answers every month`}
    >
      people see {brandName} in AI answers every month
    </p>
    <AreaChart
      className={styles.reachTrend}
      height={56}
      points={reach.series}
    />
    <p className={styles.reachNote}>
      An estimate of how many people see {brandName} mentioned across AI
      platforms each month. Use it to evaluate the real-world scale of its AI
      visibility.
    </p>
  </section>
)

interface MentionsCardProps {
  mentions: BrandDashboard['mentions']
  period: BrandDashboard['period']
}

export const MentionsCard: FC<MentionsCardProps> = ({ mentions, period }) => (
  <section className={classNames(styles.card, styles.mentionsCard)}>
    <div className={styles.cardHeader}>
      <div>
        <h2 className={styles.cardTitleSm}>Total AI Mentions</h2>
        <p className={styles.cardSubtitle}>
          All platforms · {moment(period.from).format('MMM D')} –{' '}
          {moment(period.to).format('MMM D')}
        </p>
      </div>
      <Pill tone="purple">Breakdown by type</Pill>
    </div>
    <div className={styles.mentionsValueRow}>
      <span className={styles.mentionsValue}>
        {formatNumber(mentions.total)}
      </span>
      <DeltaBadge kind="percent" value={mentions.delta} />
    </div>
    <AreaChart
      className={styles.mentionsTrend}
      height={110}
      points={mentions.series}
      showDates
    />
    <StanceSplit split={mentions.split} />
  </section>
)
